/**
 * Author: Nigel Leck
 */
import { serviceCall } from "@/helpers/register";
import { validateGreenId } from "@/helpers/greenid";
import { validateCentre } from "@/helpers/centre";
import { validateDPIN } from "@/helpers/directorpin";
import { activateUser } from "@/helpers/activateuser";
import Auth from "@aws-amplify/auth";
import store from '@/store'


export function initialize() {
  let p = new Promise(function(resolve, reject) {
    let configure = Auth.configure();
    if (configure.userPoolId) {
      resolve(configure);
    } else {
      doInitialize(resolve, reject);
    }
  });

  return p;
}

export async function storeCenterDetails(store) {
  // console.log( "storeCenterDetails", store);
  await initialize();
  try {
    let session = await Auth.currentSession();

    // console.log( "got session", session);
    if (session && session.idToken && session.idToken.payload) {
      let attributes = Object.assign({}, session.idToken.payload);
      let data = {
        username: attributes["cognito:username"],
        attributes: attributes
      };
      attributes.address = attributes.address.formatted;

      store.commit("SET_SERVICE", data);
      return attributes;
    }
  } catch (err) {
    // console.log("Error", err);
  }
  return {};
}

export function serviceCallWithAuth(serviceName, options) {
  
  // let jwt = Authentication.jwt();

  let p = new Promise(function(resolve, reject) {
    try {
      let tmp = Object.assign({}, options);
      let headers = Object.assign({}, tmp.headers);
      // headers.Authorization = jwt.id_token;
      tmp.headers = headers;
    //  let objSENumber = options.searchParams.seNumber;

      if (typeof store.getters.getService.seNumber != 'undefined')
        tmp.searchParams = Object.assign(
          {seNumber: store.getters.getService.seNumber},
          tmp.searchParams
        );

        if(options.path === '/greenid') {
          validateGreenId(tmp)
          .then(result => {
            console.log("validation passed"+result.statusCode)
            if(result!=null && (result.statusCode>=400 && result.statusCode<499 || result.statusCode==500))
            {
              let err={message:result.body}
              reject(err)
            }else{
              resolve(result)
              return p;
            }
           
          })
          .catch(err => {
            console.log("validation failed"+err)
            reject(err)
          });
        } else if(options.path === '/centre') {
          validateCentre(tmp)
            .then(result => resolve(result))
            .catch(err => reject(err));
        } else if(options.path === '/director-pin') {
        
          validateDPIN(tmp)
          .then(result => resolve(result))
          .catch(err => reject(err));
        } else if(options.path.startsWith('/users/')) {
          activateUser(tmp)
            .then(result => resolve(result))
            .catch(err => reject(err));
        } else {
          serviceCall(serviceName, tmp)
            .then(result => resolve(result))
            .catch(err => reject(err));
        }
      }
      catch(err) {
        // console.log( "getJWT", err);
        if (err.code) {
          reject(err);
        } else {
          reject({
            code: "NoCurrentUser",
            message: err.toString(),
            navigate: "auth-login"
          });
        }
      }
  });

  return p;
}

async function doInitialize(resolve, reject) {
  // console.log( "doInitialize");
  serviceCall("register", {
    path: "/config"
  })
    .then(response => {
      // console.log( response);
      response.Auth.cookieStorage = {
        domain: window.location.hostname,
        secure: true,
        path: "/",
        expires: 30
      };
      response.storage = window.localStorage;
      let config = Auth.configure(response);

      resolve(config);
    })
    .catch(err => {
      // console.log("Error:", err);
      reject(err);
    });
}

function getUrlVars() {
  var vars = {};
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(
    m,
    key,
    value
  ) {
    vars[key] = decodeURIComponent(value);
  });
  return vars;
}

export function confirmSignUp(result, username, token) {
  let p = new Promise(function(resolve, reject) {
    if (!result) {
      reject({ message: "validation failed" });
    } else {
      let args = getUrlVars();
      let tmpUsername = username || args["username"];
      if (!tmpUsername) {
        reject({ message: "No SE Number", navigate: "auth-register" });
      }

      if (!token) {
        reject({ message: "no token" });
      }
      initialize().then(function() {
        doConfirmSignUp(tmpUsername, token, resolve, reject);
      });
    }
  });

  return p;
}

async function doConfirmSignUp(seNumber, code, resolve, reject) {
  try {
    // console.log( "doConfirmSignUp( " + seNumber + ", code: " + code);
    let newPassword = document.getElementById("authPassword").value;
    // console.log( newPassword);
    const user = await Auth.signIn(seNumber, code);
    // console.log( user);
    const loggedUser = await Auth.completeNewPassword(user, newPassword);
    resolve(loggedUser);
  } catch (err) {
    // console.log("Error", err);
    reject(err);
  }
}

export function doSignOut() {
  let p = new Promise(function(resolve, reject) {
    initialize().then(callSignOut(resolve, reject));
  });

  return p;
}

export function doResend() {
  let p = new Promise(function(resolve, reject) {
    initialize().then(function() {
      callResend(resolve, reject);
    });
  });

  return p;
}

export function doReset(result) {
  let p = new Promise(function(resolve, reject) {
    if (!result) {
      reject({ code: "Invalid", message: "Validation error" });
    } else {
      initialize().then(function() {
        callReset(resolve, reject);
      });
    }
  });

  return p;
}

export function doResetComplete(result) {
  let p = new Promise(function(resolve, reject) {
    if (!result) {
      reject({ code: "validation", message: "Validation falied" });
    } else {
      if (!resettingUsername) {
        reject({
          code: "NoUsername",
          message: "No Username",
          navigate: "auth-password-reset"
        });
      } else {
        initialize()
          .then(callResetComplete)
          .then(resolve)
          .catch(reject);
      }
    }
  });

  return p;
}

export function doLogin(result) {
  let p = new Promise(function(resolve, reject) {
    if (!result) {
      reject({ code: "Invalid", message: "Validation error" });
    } else {
      initialize()
        .then(callLogin)
        .then(resolve)
        .catch(reject);
    }
  });

  return p;
}

export function doChange(result) {
  let p = new Promise(function(resolve, reject) {
    if (!result) {
      reject(result);
    } else {
      initialize()
        .then(callChange)
        .then(resolve)
        .catch(reject);
    }
  });

  return p;
}

async function callLogin() {
  try {
    let seNumber = document.getElementById("authSeNumber").value;
    let username =
      "SE-" + "00000000".substring(1, 9 - seNumber.length) + seNumber;
    let password = document.getElementById("authPassword").value;

    const user = await Auth.signIn(username, password);

    // console.log( user);
    if (
      user.challengeName === "SMS_MFA" ||
      user.challengeName === "SOFTWARE_TOKEN_MFA"
    ) {
      // You need to get the code from the UI inputs
      // and then trigger the following function with a button click
      const code = "@TODO: getCodeFromUserInput()";

      let mfaType = "@TODO: what MFA?";
      // If MFA is enabled, sign-in should be confirmed with the confirmation code
      await Auth.confirmSignIn(
        user, // Return object from Auth.signIn()
        code, // Confirmation code
        mfaType // MFA Type e.g. SMS_MFA, SOFTWARE_TOKEN_MFA
      );
      // console.debug( loggedUser);
    } else if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
      // const { requiredAttributes } = user.challengeParam; // the array of required attributes, e.g. ['email', 'phone_number']
      // // You need to get the new password and required attributes from the UI inputs
      // // and then trigger the following function with a button click
      // // For example, the email and phone_number are required attributes
      // const { username, email, phone_number } = getInfoFromUserInput();
      // let newPassword="@TODO: fetch password.";

      const loggedUser = await Auth.completeNewPassword(
        user, // the Cognito User Object
        password // the new password
        // OPTIONAL, the required attributes
        //     {
        //         email,
        //         phone_number,
        //     }
      );
      return loggedUser;
    } else if (user.challengeName === "MFA_SETUP") {
      // This happens when the MFA method is TOTP
      // The user needs to setup the TOTP before using it
      // More info please check the Enabling MFA part
      Auth.setupTOTP(user);
    } //else {
    // The user directly signs in
    //    console.log(user);
    //   }
    // To initiate the process of verifying the attribute like 'phone_number' or 'email'
    return user;
  } catch (err) {
    if (err.code === "UserNotConfirmedException") {
      // The error happens if the user didn't finish the confirmation step when signing up
      // In this case you need to resend the code and confirm the user
      // About how to resend the code and confirm the user, please check the signUp part
    } else if (err.code === "PasswordResetRequiredException") {
      // The error happens when the password is reset in the Cognito console
      // In this case you need to call forgotPassword to reset the password
      // Please check the Forgot Password part.
    } else if (err.code === "NotAuthorizedException") {
      // The error happens when the incorrect password is provided
    } else if (err.code === "UserNotFoundException") {
      // The error happens when the supplied username/email does not exist in the Cognito user pool
    } else {
      // console.log("Error:", err);
    }

    throw err;
  }
}
let resettingUsername = null;
async function callReset(resolve, reject) {
  try {
    let seNumber = document.getElementById("authSeNumber").value;
    let username =
      "SE-" + "00000000".substring(1, 9 - seNumber.length) + seNumber;

    resettingUsername = username;
    const reset = await Auth.forgotPassword(username);
    resolve(reset);
  } catch (err) {
    if (err.code === "NotAuthorizedException") {
      reject({
        code: "RegistrationNotComplete",
        message: "Registration not complete",
        navigate: "auth-register"
      });
    } else {
      reject(err);
    }
  }
}

async function callResend(resolve, reject) {
  if (!resettingUsername) {
    reject({
      code: "NoUsername",
      message: "No SE number to reset",
      navigate: "auth-password-reset"
    });
  } else {
    try {
      const reset = await Auth.forgotPassword(resettingUsername);
      resolve(reset);
    } catch (err) {
      if (err.code === "NotAuthorizedException") {
        reject({
          code: "RegistrationNotComplete",
          message: "Registration not complete",
          navigate: "auth-register"
        });
      } else {
        reject(err);
      }
    }
  }
}

async function callChange() {
  let oldPassword = document.getElementById("settingsCurrentPassword").value;
  let newPassword = document.getElementById("settingsPassword").value;
  let confirmPassword = document.getElementById("settingsConfirmPassword")
    .value;

  if (confirmPassword != newPassword) {
    throw {
      name: "PasswordMissMatch",
      message: "Passwords do not match"
    };
  }

  const currentUser = await Auth.currentAuthenticatedUser();
  const result = await Auth.changePassword(
    currentUser,
    oldPassword,
    newPassword
  );

  return result;
}

async function callSignOut(resolve, reject) {
  try {
    const result = await Auth.signOut();

    resolve(result);
  } catch (err) {
    reject(err);
  }
}

async function callResetComplete() {
  let token = document.getElementById("token").value;
  let newPassword = document.getElementById("authPassword").value;
  let confirmPassword = document.getElementById("authConfirmPassword").value;

  if (newPassword != confirmPassword) {
    throw {
      name: "PasswordMissMatch",
      message: "Passwords do not match"
    };
  }

  // Collect confirmation code and new password, then
  await Auth.forgotPasswordSubmit(resettingUsername, token, newPassword);
  const user = await Auth.signIn(resettingUsername, newPassword);
  return user;
}
